import { ApiResult } from 'common/models';
import { HttpClient } from 'common/services/http-client.service';

import { CategoryDTO, EntityDetails, Source } from 'common/models/data/entity.model';
import { IErrorApiResponse } from 'common/models/api-service/error-response.model';
import { EntityDetailsPayload } from 'common/models/data/entityStore.model';
import entityConfig from './entity.config';
import { IndicatorVM } from 'common/models/data/indicator.model';
import { ApiInitiator } from 'common/enums/data.enum';

export class EntityService extends HttpClient {
    public static async getEntityDetails(
        payload: EntityDetailsPayload
    ): Promise<ApiResult<EntityDetails | IErrorApiResponse> | undefined> {
        return EntityService.invokeApi<EntityDetails | IErrorApiResponse>(
            entityConfig.getEntityDetailsUrl(payload)
        );
    }

    public static async getCategoryDetailsById(
        payload: EntityDetailsPayload
    ): Promise<ApiResult<CategoryDTO | IErrorApiResponse> | undefined> {
        return EntityService.invokeApi(entityConfig.getCategoryDetailsUrl(payload));
    }

    public static async getIndicatorDetailsById(
        payload: EntityDetailsPayload
    ): Promise<ApiResult<IndicatorVM | IErrorApiResponse> | undefined> {
        return EntityService.invokeApi(entityConfig.getIndicatorDetailsByIdUrl(payload));
    }

    public static async getSources(
        payload: ApiInitiator
    ): Promise<ApiResult<Array<Source> | IErrorApiResponse> | undefined> {
        return EntityService.invokeApi(entityConfig.getSourcesUrl(payload));
    }
}
